import { ErrorFill16 } from 'ui/icons/aurora/16px/ErrorFill16';
import { WarningFill } from 'ui/icons/status/WarningFill';
import { utilityColors } from 'ui/theme/colors';
import { ErrorTypes, ErrorWarningTextProps } from '../types';
import {
  StyledBannerMessage,
  StyledContainer,
  StyledPositioner,
  StyledSubMessage,
} from './ErrorAccordion.styled';

export const theme: Record<ErrorTypes, any> = {
  [ErrorTypes.Error]: {
    Icon: ErrorFill16,
    errorColor: utilityColors.negative100,
    errorMessage: 'Invalid content',
  },
  [ErrorTypes.Warning]: {
    Icon: WarningFill,
    errorColor: utilityColors.warning100,
    errorMessage: 'Required before sending campaign',
  },
};

export const ErrorWarningBannerText = ({
  message,
  subMessage,
  type,
  ...props
}: ErrorWarningTextProps) => {
  const { Icon, errorColor } = theme[type];
  return (
    <StyledContainer {...props}>
      <StyledPositioner>
        <Icon color={errorColor} />
        <StyledBannerMessage data-type={type}>{message}</StyledBannerMessage>
      </StyledPositioner>
      {subMessage && <StyledSubMessage>{subMessage}</StyledSubMessage>}
    </StyledContainer>
  );
};
